const defaultStyle = {
  backgroundImage: "url(/higurashi/background.webp)",
  backgroundSize: "100% auto",
  backgroundRepeat: "repeat",
  backgroundPosition: "top center",
};

const backgroundStyles = {
  Tickets: defaultStyle,
  MyPage: defaultStyle,
  Quests: defaultStyle,
  Hints: defaultStyle,
  HowToUse: defaultStyle,
  Rules: defaultStyle,
  News: defaultStyle,
  EmailSettings: defaultStyle,
  PayPayCheck: defaultStyle,
  PayPayPolling: defaultStyle,
  PayPayConfirm: defaultStyle,
};

export default backgroundStyles;
